module.exports = __webpack_public_path__ + "img/pattern1 blue copy 2.cc2db958.svg";